import { INGESTION_CONSTANTS, INGESTION_STATUS_LABELS } from '../../utilities/Ingestion.constants';

export type TIngestionMode = 'DSViewDataSource' | 'TableViewDataSource' | 'table';

export const STOP = 'Stop';
export const START = 'Start';

const SELECTIVE_INGESTION_LABEL = 'Selective';
const INGESTION_LABEL = 'Ingestion';
const INGESTION_LABEL_LOWER = INGESTION_LABEL.toLowerCase();
const TABLE_LABEL = 'Table';
const TABLE_LABEL_LOWER = TABLE_LABEL.toLowerCase();
const PROFILE_LABEL = 'Profile';
const SHEET_LABEL = 'Sheet';
const DATA_SOURCE_LABEL = 'data source';

export const RUNNING_ON_TABLES = `${INGESTION_STATUS_LABELS[INGESTION_CONSTANTS.RUNNING]} on ${TABLE_LABEL_LOWER}s`;
export const STOPPING_ON_TABLES = `${INGESTION_STATUS_LABELS[INGESTION_CONSTANTS.TRIGGERED_STOP]} on ${TABLE_LABEL_LOWER}s`;

export const INGESTION_BY_TABLE_TEXT = {
  tooltips: {
    startTable: `${START} ${INGESTION_LABEL_LOWER} on a specific ${TABLE_LABEL_LOWER}.`,
    stopTable: `${STOP} ${INGESTION_LABEL_LOWER} on this ${TABLE_LABEL_LOWER}.`,
    disabled: {
      ds: `This ${DATA_SOURCE_LABEL} does not use tables.`,
      dsRunning: `Per-${TABLE_LABEL_LOWER} ${INGESTION_LABEL_LOWER} is disabled until current jobs are done.`,
      stopping: `${INGESTION_LABEL} is not available until stopping is complete.`,
      dsStopping: `Per-${TABLE_LABEL_LOWER} ${INGESTION_LABEL} is not available until stopping is complete.`,
      fullRunning: `Cannot trigger an ${INGESTION_LABEL_LOWER} while a full ${INGESTION_LABEL_LOWER} is running.`,
      fullRunningTable: `Cannot trigger per-${TABLE_LABEL_LOWER} ${INGESTION_LABEL_LOWER} while a full ${INGESTION_LABEL_LOWER} is running.`,
      fullStoppingTable: `Cannot trigger per-${TABLE_LABEL_LOWER} ${INGESTION_LABEL_LOWER} while a full ${INGESTION_LABEL_LOWER} is stopping.`,
      fullRunningLoading: `Per-${TABLE_LABEL_LOWER} ${INGESTION_LABEL} is not available ${INGESTION_LABEL_LOWER} status is loading.`,
    },
    stopDS: `${STOP} ${INGESTION_LABEL_LOWER} for this ${DATA_SOURCE_LABEL}.`,
    startDS: `${START} ${INGESTION_LABEL_LOWER} for this ${DATA_SOURCE_LABEL}.`,
  },
};

const SELECTIVE_TABLE_INGESTION_LABEL = `${SELECTIVE_INGESTION_LABEL} ${TABLE_LABEL} ${INGESTION_LABEL}`;
const SELECTIVE_API_INGESTION_LABEL = `${SELECTIVE_INGESTION_LABEL} ${PROFILE_LABEL} ${INGESTION_LABEL}`;
const SELECTIVE_SHEET_INGESTION_LABEL = `${SELECTIVE_INGESTION_LABEL} ${SHEET_LABEL} ${INGESTION_LABEL}`;

export const INGESTION_BY_DATA_SOURCE_TEXT = {
  toolbarText: {
    dataSources: `${SELECTIVE_INGESTION_LABEL} ${INGESTION_LABEL}`,
    tables: {
      // There are only values entered for the rdbms, xls, & api data source types
      1: SELECTIVE_TABLE_INGESTION_LABEL,
      2: SELECTIVE_TABLE_INGESTION_LABEL,
      3: SELECTIVE_TABLE_INGESTION_LABEL,
      4: SELECTIVE_TABLE_INGESTION_LABEL,
      7: SELECTIVE_API_INGESTION_LABEL,
      8: SELECTIVE_TABLE_INGESTION_LABEL,
      11: SELECTIVE_TABLE_INGESTION_LABEL,
      12: SELECTIVE_TABLE_INGESTION_LABEL,
      13: SELECTIVE_SHEET_INGESTION_LABEL,
      14: SELECTIVE_SHEET_INGESTION_LABEL,
      15: SELECTIVE_SHEET_INGESTION_LABEL,
    },
  },
};

export const DATASOURCE_BY_TABLE_TYPES = {
  // There are only values entered for the rdbms, xls, & api data source types
  1: TABLE_LABEL,
  2: TABLE_LABEL,
  3: TABLE_LABEL,
  4: TABLE_LABEL,
  7: PROFILE_LABEL,
  8: TABLE_LABEL,
  11: TABLE_LABEL,
  12: TABLE_LABEL,
  13: SHEET_LABEL,
  14: SHEET_LABEL,
  15: SHEET_LABEL,
};

export type TDataSourceTypesAllowed = 1 | 2 | 3 | 4 | 7 | 8 | 11 | 12 | 13 | 14 | 15;

const FAILED_TO_FETCH = 'Failed to fetch';
const FAILED_TO_FETCH_TABLES = `${FAILED_TO_FETCH} ${TABLE_LABEL.toLocaleLowerCase()}s.`;
const FAILED_TO_FETCH_PROFILES = `${FAILED_TO_FETCH} ${PROFILE_LABEL.toLocaleLowerCase()}s.`;
const FAILED_TO_FETCH_SHEETS = `${FAILED_TO_FETCH} ${SHEET_LABEL.toLocaleLowerCase()}s.`;

export const ERROR_LABELS = {
  dataSources: `${FAILED_TO_FETCH} data sources.`,
  tables: {
    1: FAILED_TO_FETCH_TABLES,
    2: FAILED_TO_FETCH_TABLES,
    3: FAILED_TO_FETCH_TABLES,
    4: FAILED_TO_FETCH_TABLES,
    7: FAILED_TO_FETCH_PROFILES,
    8: FAILED_TO_FETCH_TABLES,
    11: FAILED_TO_FETCH_TABLES,
    12: FAILED_TO_FETCH_TABLES,
    13: FAILED_TO_FETCH_SHEETS,
    14: FAILED_TO_FETCH_SHEETS,
    15: FAILED_TO_FETCH_SHEETS,
  },
};
